import { z } from 'zod/v3'

export const resetPasswordSearchSchema = z.object({
	// Tolerant parse: a missing/garbage token becomes '' and routes to the invalid-link state
	// rather than a raw router error.
	token: z.string().catch(''),
})

export type ResetPasswordSearch = z.infer<typeof resetPasswordSearchSchema>
